import { Fragment } from 'react';
import { View } from 'react-native';

import { Avatar, Text } from '@squire/ui';

import { ChevronRightIcon } from '@/components/_icons/ChevronRightIcon';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { ServiceCategoryBreadcrumbProps } from './types';

export const ServiceCategoryBreadcrumb = ({
  testID,
  barberName,
  barberPhotoUrl,
  categoryName,
  subcategoryName,
}: ServiceCategoryBreadcrumbProps) => {
  const { t } = useScreenTranslations('ServiceCategoryBreadcrumb');
  const items = [
    { key: 'category', name: categoryName },
    { key: 'subcategory', name: subcategoryName },
  ].filter((item) => Boolean(item.name));

  return (
    <View testID={testID} style={styles.container}>
      {barberName ? (
        <Avatar
          shape="circle"
          size="xxs"
          uri={barberPhotoUrl}
          fallbackText={barberName}
        />
      ) : null}
      <Text
        variant="m"
        style={items.length > 0 ? styles.label : styles.currentLabel}
      >
        {barberName ?? t('anyProfessional')}
      </Text>
      {items.map(({ key, name }, index) => (
        <Fragment key={key}>
          <ChevronRightIcon
            testID="breadcrumb-chevron"
            size={12}
            color="iconTertiary"
          />
          <Text
            variant="m"
            style={
              index === items.length - 1 ? styles.currentLabel : styles.label
            }
            numberOfLines={1}
          >
            {name}
          </Text>
        </Fragment>
      ))}
    </View>
  );
};
